import {
  FirstLastSummaryCalculations,
  FirstLastSummaryIndexDictionaryDto,
  OpmFirstLastWaterfallDictionaryDto,
} from '@app/shared/models/contracts/opm-calculation-results-dto';
import { l, translationKeys } from '@locale/setupI18n';
import styles from '@app/modules/projects/outputs/opm-summary-waterfall/opm-summary-waterfall-erf.module.scss';
import CellValue from '@app/shared/components/cell-value/CellValue';
import {
  enteredPercentageViewRules,
  amountRules,
  numberCalculatedViewRules,
} from '@app/shared/components/cell-value/CellValueConfigurations';
import classNames from 'classnames';
import { simulationSectionsDefinition } from '../../helper/FirstLastHelpers';
import { getCalculatedProjectValueInPercent } from '@app/shared/formatters';

type IterationKeys = Omit<FirstLastSummaryCalculations, 'instruments'>;

interface IterationLevelRowProps {
  label: translationKeys;
  valueKey: keyof IterationKeys;
  opmWaterfall: OpmFirstLastWaterfallDictionaryDto;
  selectedYear: string;
  waterfallIterations: number;
  isPercentage?: boolean;
  className?: string;
  decimalPoint?: number | null;
}

const IterationLevelRow: React.FC<IterationLevelRowProps> = ({
  label,
  valueKey,
  opmWaterfall,
  selectedYear,
  waterfallIterations,
  isPercentage = false,
  className = '',
  decimalPoint = null,
}: IterationLevelRowProps) => (
  <tr>
    <td className={classNames(className, styles['border-right'])} data-testid={`${valueKey}-title`}>
      {l(label)}
    </td>
    {simulationSectionsDefinition.map((section, outerIndex) =>
      Object.entries(opmWaterfall[selectedYear][section]).map(([key, _], innerIndex) => {
        const value = (opmWaterfall[selectedYear][section] as FirstLastSummaryIndexDictionaryDto)[
          key
        ][valueKey];

        return (
          <td
            key={`${section}-${key}`}
            className={classNames(className, {
              [styles['border-right']]: outerIndex === 0 && innerIndex + 1 === waterfallIterations,
            })}
            data-testid={`${valueKey}-simulation-${key}`}>
            <CellValue
              value={
                isPercentage && typeof value === 'number'
                  ? getCalculatedProjectValueInPercent(value)
                  : value
              }
              {...(isPercentage ? enteredPercentageViewRules : amountRules)}
              {...(decimalPoint !== null && numberCalculatedViewRules)}
              normalize
            />
          </td>
        );
      })
    )}
  </tr>
);

export default IterationLevelRow;
